import React from 'react';
import { Box, Grid } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'isnull',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
    },
  ],
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} mb={2} />
        <Grid item {...COMMON_STYLES.gridItem}>
          <SourceColumnField
            value={transform.sourceColumns[0] || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].sourceColumns = [e.target.value];
              setFieldValue('transformations', newTransforms);
            }}
            headers={headers}
            disabled={disableForm}
            error={!!errors?.sourceColumns}
            helperText="Select column for null check"
          />
        </Grid>
        <Grid item {...COMMON_STYLES.gridItem}>
          <OutputColumnField
            value={transform.outputColumn || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].outputColumn = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            disabled={disableForm}
            error={!!errors?.outputColumn}
            helperText={errors?.outputColumn || 'Will contain true/false indicating valid dates'}
          />
        </Grid>
      </Grid>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title='Is Empty? - Check for null/empty values ("" → true)' disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_IsNull = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={COMMON_VALIDATION}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Is Empty?"
  />
);

export default NodeModal_IsNull;
